<template>
  <div class="first-section">
    <div class="heading">
      <div class="title">
        <h2>{{$ml.get(`Fertigation`)}}</h2>
        <info-tip :title="$ml.get(`Select the stage of your crop and after filling all the fields click the button Get fertigation recipe. Your fertilizers will be divided in different tanks according to their compatibility.`)"/>
      </div>
    </div>

    <div class="form">
      <app-sel
        v-model="form.stageId"
        :label="$ml.get(`Select stage`)"
        :items="stages"
        key-name="Id"
        label-name="Name"
      >
        <template v-slot="{ items }">
            <app-sel-opt :value="item" v-for="item in items">
                {{ $ml.get(item.Name) }}
            </app-sel-opt>
        </template>
      </app-sel>

      <app-text-input
        v-model.number="form.temperature"
        :label="$ml.get(`Temperature`)"
        hint="C"
        class="temperature"
        type="number"
        min="0"
        :step="1"
        :digits-after-dot="0"
      />

      <template v-if="program.fertigation === 'proportional'">
        <app-text-input
          v-if="$store.getters['program/data'].type == 'soil-based'"
          v-model.number="form.waterPerStage"
          :label="$ml.get(`Water per stage`)"
          class="for-proportional"
          hint="m3" 
          type="number"
          min="0"
          :digits-after-dot="1"
        />
        <app-text-input
          v-if="$store.getters['program/data'].type == 'soil-based'"
          v-model.number="form.fertigationInterval"
          :label="$ml.get(`Fertigation interval`)"
          class="for-proportional"
          :hint="$ml.get('days')"
          type="number"
          :min="form.irrigationInterval"
          :step="1"
          :digits-after-dot="0"
        />
        <app-text-input
          v-if="$store.getters['program/data'].type == 'soil-based'"
          v-model.number="form.irrigationInterval"
          :label="$ml.get(`Irrigation interval`)"
          class="for-proportional"
          :hint="$ml.get('days')"
          type="number"
          min="0"
          :step="1"
          :digits-after-dot="0"
        />
        <app-text-input
          v-if="$store.getters['program/data'].type == 'hydroponic'"
          v-model.number="form.ec"
          :label="'EC'"
          class="for-proportional"
          hint="dS/m"
          type="number"
          min="0"
          :digits-after-dot="1"
        />
      </template>
      <app-btn
        :disabled="form.irrigationInterval > form.fertigationInterval"
       :loading="loading.tanks" @click="loadTanks">
        {{$ml.get(`get FERTIGATION RECIPE`)}}
      </app-btn>

      <p
        style="color: #E8282F;"
        v-if="form.irrigationInterval > form.fertigationInterval"
      >
        {{$ml.get('Fertigation interval must be greater than irrigation interval!')}}
      </p>
      
    </div>

    <!-- <div class="buttons">

    </div> -->
  </div>
</template>

<script>
import API from '@/api';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: {
        tanks: false,
      },
      water: {}
    }
  },

  methods: {

    //==========================================================================
    loadTanks() {

      if(!this.validate()) {
        return;
      }

      this.loading.tanks = true;
      this.$store.dispatch('program/fertigation/getTanks')
      .then(() => {
        this.$store.dispatch('program/fertigation/save');
        this.$store.dispatch('program/canGoToNextStep', true);
      })
      .catch(err=>{
        this.handleErrorAsNotifications, 
        this.$store.dispatch('program/canGoToNextStep', false)
        this.$notify({
            group: "notices",
            title: this.$ml.get(`None of the selected fertilizers are used.`),
            type: "error",
          });
          this.$notify({
            group: "notices",
            title: this.$ml.get(`Enter the amount manually or select other fertilizers.`),
            type: "error",
          });
      })
      .finally(() => {
        this.loading.tanks = false;
      });
    },
    //==========================================================================

    onWaterPerStage(value) {
      if(this.tanks.length) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$store.dispatch('program/fertigation/updateTanksWithWaterPerStage');
          this.$store.commit('program/fertigation/setNewPrevWaterPerStage', value);
        }, 500);
      }
    },


    validate() {
      if(this.program.fertigation == 'proportional' && this.$store.getters['program/data'].type == 'soil-based') {
        if(!this.form.fertigationInterval) {
          this.$notify({
            group: 'notices',
            title: this.$ml.get('Enter fertigation interval'),
            type: 'error',
          });
          return false;
        }
        if(!this.form.irrigationInterval) {
          this.$notify({
            group: 'notices',
            title: this.$ml.get('Enter irrigation interval'),
            type: 'error',
          });
          return false;
        }

        // if(this.form.fertigationInterval > this.form.irrigationInterval) {
        //   this.$store.commit('modals/alert/open', {
        //     text: this.$ml.get('Fertigation interval cannot be less than irrigation interval'),
        //   });
        //   return false;
        // }
      }

      if(!this.form.temperature) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get('Enter temperature'),
          type: 'error',
        });
        return false;
      }

      if(!this.form.stageId) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get('Select stage'),
          type : 'error',
        });
        return false;
      }

      return true;
    }
  },

  computed: {
    ...mapGetters({
      // stages: 'program/stages',
      form: 'program/fertigation/form',
      tanks: 'program/fertigation/tanks',
      program: 'program/data',
      stages: 'program/fertigation/stages'
    })
  },
  created () {

    this.$store.dispatch('program/fertigation/loadStages');

    if (this.program.type != 'hydroponic')
      return false;

    var waterId = this.program.waterTestId;

    API.program.getWaterTestsByField(this.program.fieldId)
      .then(res => res.data.data)
      .then(data => {
        if (waterId != null) {
          this.water = data.find(item => item.id === waterId);
          if (!this.water.data.ec)
            this.water.data = JSON.parse(this.water.data);
        }
      });
  },
  watch: {
    'form.stageId': function (val) {
      if (this.program.type != 'hydroponic')
        return false;

      var temp = this.stages.find(item => item.Id === val);
      var water = this.water.data ? this.water.data.ec : 0;
      this.form.ec = (temp.IrrWaterEc + Number(water)).toFixed(2);
    }
  }
}
</script>

<style lang="scss" scoped>

.first-section {

  // padding: 0 48px;
  // padding-top: 50px;

  .heading {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    h2 {
      margin: 32px 0;
    }

    > button:last-child {
      // align-self: flex-end;
      margin: 0 16px 0 auto;
    }
  }

  .form {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-right: -16px;
    margin-left: -16px;
    padding-top: 24px;
    flex-wrap: wrap;

    > * {
      // max-width: 200px;
      flex-basis: calc(33% - 32px);
      margin-bottom: 30px;
      margin-right: 16px;
      margin-left: 16px;
    }

    .app-sel {
      // margin-right: 40px;

      min-width: 240px;
      // width: calc(33% - 16px);

    }

    .text-input {
      // margin-right: 30px;
      // margin-bottom: 30px;
      // width: calc(33% - 16px);

      // margin-right: 32px;
      &:last-child {

      }
    }

    @media (max-width: 1400px) {


      // .for-proportional {
      //   width: calc(33.33% - 30px);
      //   flex-grow: 1;
      // }
      //
      // .temperature {
      //   flex-basis: 200px;
      //   flex-grow: 1;
      // }
    }
  }

  .buttons {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    width: 100%;

    .report {
      margin-left: 20px;
    }
  }
  @media (max-width: 768px) {
    .form {
      margin-right: 0;
      margin-left: 0;
      > * {
        margin-right: 0;
        margin-left: 0;
        width: 100%;
        flex-basis: 100%;
      }
    }
  }
}

</style>
